import { render, staticRenderFns } from "./GraduatesSingle.vue?vue&type=template&id=c190ce28&"
import script from "./GraduatesSingle.vue?vue&type=script&lang=js&"
export * from "./GraduatesSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports